import { DataFieldRuleValidator } from "./types";

export const dataFieldIsEmpty: DataFieldRuleValidator = {
	validate(_, __, dataFieldValue): boolean {
		return dataFieldValue === null;
	},

	getErrorMessage: () => {
		return "";
	},
};
